<template>
  <nav class="navigation" :class="isOpen ? 'navigation--open' : ''" @click="clickOutside($event)">
    <div class="navigation__wrapper">
      <div class="navigation__close-icon" @click="close">
        <img src="@/assets//img/pictos/croix-menu.svg" alt="" />
      </div>

      <div class="navigation__section navigation__section--first">
        <p class="big-title">Menu</p>
        <p>Oui, oui, tout est là ! ♡</p>
      </div>

      <ul v-if="admin" class="navigation__section">
        <li class="navigation__item--title">
          <span>Admin</span>
        </li>

        <li class="navigation__item">
          <router-link :to="{ name: 'Profile', query: { limit: 50 } }" tag="a">
            Profil
          </router-link>
        </li>

        <li class="navigation__item">
          <router-link :to="{ name: 'dashboard' }" tag="a">
            Chiffres d'affaire
          </router-link>
        </li>

        <li class="navigation__item">
          <router-link :to="{ name: 'coupons-admin' }" tag="a">
            Coupons
          </router-link>
        </li>

        <li class="navigation__item">
          <router-link :to="{ name: 'carts-admin', query: { limit: 20 } }" tag="a">
            Paniers
          </router-link>
        </li>

        <li class="navigation__item">
          <router-link :to="{ name: 'shipping-admin', query: { limit: 50 } }" tag="a">
            Expéditions
          </router-link>
        </li>
      </ul>

      <ul class="navigation__section">
        <li class="navigation__item--title">
          <router-link :to="{ name: 'creative-craft' }" tag="a">
            Matériel créatif
          </router-link>
        </li>

        <li class="navigation__item">
          <router-link :to="{ name: 'alphabet-stamps' }" tag="a">
            Sets de tampons alphabet
          </router-link>
        </li>

        <li class="navigation__item">
          <router-link :to="{ name: 'micro-alphabet-stamps' }" tag="a">
            Sets de micro tampons alphabet
          </router-link>
        </li>

        <li class="navigation__item">
          <router-link :to="{ name: 'alphabet-stamp-accessories' }" tag="a">
            Accessoires coffrets tampons alphabet
          </router-link>
        </li>

        <li class="navigation__item">
          <router-link :to="{ name: 'accessories-box' }" tag="a">
            Plateau de rangement
          </router-link>
        </li>

        <li class="navigation__item">
          <router-link :to="{ name: 'accessories-lid' }" tag="a">
            Couvercle personnalisé
          </router-link>
        </li>

        <li class="navigation__item">
          <router-link :to="{ name: 'accessories-pliers' }" tag="a">
            Pinces à lettre
          </router-link>
        </li>

        <li class="navigation__item">
          <router-link :to="{ name: 'accessories-bar' }" tag="a">
            Réglette d'alignement
          </router-link>
        </li>

        <li class="navigation__item">
          <router-link :to="{ name: 'accessories-double-bar' }" tag="a">
            Réglette d'alignement double
          </router-link>
        </li>

        <li class="navigation__item">
          <router-link :to="{ name: 'cookie-cutters' }" tag="a">
            Emporte-pièce
          </router-link>
        </li>

        <li class="navigation__item">
          <router-link :to="{ name: 'custom-cutters' }" tag="a">
            Emporte-pièce sur mesure
          </router-link>
        </li>

        <li class="navigation__item">
          <router-link :to="{ name: 'tourninouneur' }" tag="a">
            Outil de traçage de cercles
          </router-link>
        </li>
      </ul>



      <ul class="navigation__section">
        <li class="navigation__item--title">
          <router-link :to="{ name: 'Checkout' }" tag="a">
            Mon panier
          </router-link>
        </li>
        <li class="navigation__item--title">
          <router-link :to="{ name: 'Profile' }" tag="a">
            Mon compte
          </router-link>
        </li>
      </ul>

      <ul class="navigation__section">
        <!-- <li class="navigation__item--title">
          <router-link :to="{ name: 'colors' }" tag="a">
            Guide des couleurs
          </router-link>
        </li> -->
        <li class="navigation__item--title">
          <router-link :to="{ name: 'faq' }" tag="a">
            Foire aux questions
          </router-link>
        </li>
        <li class="navigation__item--title">
          <router-link :to="{ name: 'cgu' }" tag="a">
            Conditions générales de vente
          </router-link>
        </li>
        <li class="navigation__item--title">
          <router-link :to="{ name: 'contact' }" tag="a">
            Contact
          </router-link>
        </li>
      </ul>

      <div class="socials">
        <nav class="socials__navigation">
          <a href="https://www.facebook.com/widddi3d" target="_blank">
            <img src="@/assets/img/pictos/facebook.svg" alt="Picto Facebook" />
          </a>
          <a href="https://www.instagram.com/widddi3d" target="_blank">
            <img src="@/assets/img/pictos/instagram.svg" alt="Picto Instagram" />
          </a>
          <a href="https://pinterest.fr/widddi3d" target="_blank">
            <img src="@/assets/img/pictos/pinterest.svg" alt="Picto Pinterest" />
          </a>
        </nav>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'WidddiNav',

  props: {
    isOpen: Boolean,
    admin: Boolean,
  },

  methods: {
    clickOutside(e) {
      const el = document.querySelector('.navigation__wrapper');

      if (el === e.target || el.contains(e.target)) {
        return;
      }

      this.close();
    },

    close() {
      this.$emit('close');
    },
  },
};
</script>
